import { render } from "./SalesDashboard.vue?vue&type=template&id=36f175ae&scoped=true"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"

import "./SalesDashboard.vue?vue&type=style&index=0&id=36f175ae&scoped=true&lang=css"
import "./SalesDashboard.vue?vue&type=style&index=1&id=36f175ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f175ae"]])

export default __exports__